import React from 'react';
import Layout from './components/Layout';
import SEO from './components/SEO';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const FounderPage: React.FC = () => {
  return (
    <Layout>
      <SEO 
        title="NOPRBLM | Founders"
        description="NOPRBLM Founders - Artist Management. Musicians, artists, technologists and global connectors."
        keywords="Clare Maguire, Blue May, Mark Tieku, NOPRBLM, artist management, musician, technologist, creative network"
        canonicalUrl="/founder"
      />
      <section className="hero-simple house-hero">
        <h1>The Founders</h1>
        
        <div className="circular-text-container">
          {/* Using SVG for curved text */}
          <svg viewBox="0 0 500 500" className="curved-text-svg founder-svg">
            <defs>
              <path
                id="founder-curve"
                d="M 250, 250 m 0, -180 a 180, 180 0 0, 1 0, 360 a 180, 180 0 0, 1 0, -360"
                fill="transparent"
              />
            </defs>
            <text className="curved-text">
              <textPath xlinkHref="#founder-curve" startOffset="25%">
                FOUNDER & THOUGHTS
              </textPath>
            </text>
          </svg>
          
          {/* Center content */}
          <div className="circular-center founder-center">
            <h2>NOPRBLM</h2>
          </div>
        </div>
        
        <p>Artist Management</p>
      </section>
      
      <section className="section">
        <div className="container-sm founder-container">
          <div className="founder-profile">
            <div className="founder-image">
              <img src="/images/Founders/clare_maguire.jpg" alt="Clare Maguire" />
            </div>
            <div className="founder-socials">
              <a href="mailto:clare@noprblm.com" className="social-icon" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
              <a href="https://www.linkedin.com/in/clare-maguire-b587b7279/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a href="https://twitter.com/claremaguire" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Twitter">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://instagram.com/claremaguire" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
          
          <div className="founder-section">
            <h2>Clare Maguire</h2>
            <div className="house-divider"></div>
            <p>
              Angel investor, developer and Trustee at Thinking About Thinking Inc. Former artist with Universal and Polydor. Connects AI research with creative enterprise.
            </p>
            
            <ul className="founder-list">
              <li><strong>Musician & Artist:</strong> Two Top-10 studio albums with Universal Music, millions of streams worldwide, and festival performances from Glastonbury to Coachella. Collaborations include The Streets, Danny Brown, Chase & Status, Jarvis Cocker, Suki Waterhouse and more.</li>
              
              <li><strong>Creative Network:</strong> Access to top writers, producers, and creative directors behind global pop icons such as Dua Lipa, Charli XCX, Sabrina Carpenter, and Chappell Roan.</li>
              
              <li><strong>Technologist & Strategist:</strong> Founder & CEO of NOPRBLM operating in London and Los Angeles, bridging artistry with data, research, and technology.</li>
              
              <li><strong>Global Connector:</strong> Co-Founder of AIFA (AI Film Academy / Awards), and CMO & Trustee of Thinking About Thinking, Inc., a nonprofit bringing together researchers from Harvard, MIT, Oxford, Stanford, DeepMind, Meta, and more.</li>
            </ul>
          </div>
          
          <div className="founder-profile">
            <div className="founder-image">
              <img src="/images/Founders/blue_may.jpg" alt="Blue May" />
            </div>
            <div className="founder-socials">
              <a href="mailto:blue@noprblm.com" className="social-icon" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div>
          
          <div className="founder-section">
            <h2>Blue May</h2>
            <div className="house-divider"></div>
            <p>
              Blue May is a Grammy nominated producer, songwriter and multi-instrumentalist with a broad range of experience across the music industry.
            </p>
            
            <ul className="founder-list">
              <li><strong>Producer & Songwriter:</strong> Worked with renowned artists including Blood Orange, Kano, and many others. Known for innovative sound design and production techniques.</li>
              
              <li><strong>Studio Expertise:</strong> Brings deep technical knowledge and creative vision to NOPRBLM's production capabilities and artist development.</li>
              
              <li><strong>Industry Network:</strong> Extensive connections across labels, studios, and creative communities in both the UK and US music scenes.</li>
            </ul>
          </div>
          
          <div className="founder-profile">
            <div className="founder-image">
              <img src="/images/Founders/mark_tieku.jpg" alt="Mark Tieku" />
            </div>
            <div className="founder-socials">
              <a href="mailto:mark@noprblm.com" className="social-icon" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div>
          
          <div className="founder-section">
            <h2>Mark Tieku</h2>
            <div className="house-divider"></div>
            <p>
              Mark Tieku, known professionally as Tieks, is a producer, DJ, and songwriter with multiple chart successes and extensive experience in the music industry.
            </p>
            
            <ul className="founder-list">
              <li><strong>Producer & Artist:</strong> Created hit singles with major artists including Florence & The Machine, with tracks reaching the UK Top 10 and garnering millions of streams.</li>
              
              <li><strong>Music Technology:</strong> Expert in cutting-edge production techniques, sound design, and digital audio technologies.</li>
              
              <li><strong>Industry Insight:</strong> Brings valuable perspective on artist development, publishing, and commercial strategy to NOPRBLM's operations.</li>
            </ul>
          </div>
          
          <div className="founder-profile">
            <div className="founder-image">
              <img src="/images/Founders/blair.jpg" alt="Blair" />
            </div>
            <div className="founder-socials">
              <a href="mailto:blair@noprblm.com" className="social-icon" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div>
          
          <div className="founder-section">
            <h2>Blair</h2>
            <div className="house-divider"></div>
            <p>
              Blair is a key member of the NOPRBLM team, bringing expertise in strategic planning, artist development, and industry coordination.
            </p>
            
            <ul className="founder-list">
              <li><strong>Management Experience:</strong> Extensive background in artist management and creative development across multiple markets.</li>
              
              <li><strong>Business Strategist:</strong> Specializes in developing sustainable business models for artists and creative professionals.</li>
              
              <li><strong>Industry Relations:</strong> Maintains valuable connections throughout the entertainment industry, facilitating key partnerships.</li>
            </ul>
          </div>

          <div className="founder-profile">
            <div className="founder-image">
              <img src="/images/Founders/phil.jpg" alt="Phil" />
            </div>
            <div className="founder-socials">
              <a href="mailto:phil@noprblm.com" className="social-icon" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div>
          
          <div className="founder-section">
            <h2>Phil</h2>
            <div className="house-divider"></div>
            <p>
              Phil brings a wealth of experience in digital innovation, marketing strategy, and content creation to the NOPRBLM team.
            </p>
            
            <ul className="founder-list">
              <li><strong>Digital Specialist:</strong> Expert in leveraging digital platforms and technologies for artist development and brand building.</li>
              
              <li><strong>Creative Direction:</strong> Contributes to visual storytelling and brand identity across NOPRBLM's various projects.</li>
              
              <li><strong>Marketing Strategy:</strong> Develops innovative approaches to audience engagement and growth across multiple channels.</li>
            </ul>
          </div>
          
          <div className="founder-case-study">
            <h3>What Sets NOPRBLM Apart</h3>
            <p>
              NOPRBLM does not operate as a traditional management company.
            </p>
            <p>
              They design architectures for success, not cookie-cutter formulas.
            </p>
            <p>
              They act as both strategic advisers and hands-on builders — combining C-suite clarity with executional detail.
            </p>
            <p>
              They work across music, artist management, fashion, sport, film, and tech, creating outcomes that are both commercially powerful and culturally undeniable.
            </p>
            <p>
              They operate at the intersection of innovation, art, and internet culture — reinventing artists, reshaping touring, and scaling influence for the next generation of global stars.
            </p>
            <p>
              In short: NOPRBLM is not just a management company. They are architects of careers — building futures where artistry, culture, and technology collide.
            </p>
          </div>
          
          <div className="founder-section">
            <h2>Contact</h2>
            <div className="house-divider"></div>
            <div className="founder-contact">
              <p>
                <a href="mailto:info@noprblm.com">info@noprblm.com</a>
              </p>
              <p>
                <a href="https://noprblm.com">noprblm.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default FounderPage;